import { useTranslation } from 'react-i18next';
import type { PriceSource } from '../../api/types';
import { StatusIcon, type StatusIconName } from '../../components/ui/StatusIcon';
import { StatusPill } from '../../components/ui/StatusPill';

/** Where the shipper price came from (#298): word + icon + colour, never colour alone (R14). */
const SOURCES: Record<
  PriceSource,
  { label: 'contract' | 'laneDefault' | 'manual'; icon: StatusIconName; bg: string; text: string }
> = {
  CONTRACT: { label: 'contract', icon: 'check', bg: 'var(--status-gray-bg)', text: 'var(--status-gray-text)' },
  LANE_DEFAULT: { label: 'laneDefault', icon: 'local_shipping', bg: 'var(--status-gray-bg)', text: 'var(--status-gray-text)' },
  MANUAL: { label: 'manual', icon: 'edit', bg: 'var(--status-amber-bg)', text: 'var(--status-amber-text)' },
};

export function RateSourcePill({ source }: { source: PriceSource }) {
  const { t } = useTranslation();
  const s = SOURCES[source];
  const label = t('shipments.rateSourcePill.label', { source: t(`shipments.rateSourcePill.${s.label}`) });
  return <StatusPill bg={s.bg} text={s.text} label={label} icon={<StatusIcon name={s.icon} />} />;
}
